import React from 'react';
import { WalmartConnectedTemplate } from 'themes/modules/channel/pages';
import { setCurrentView } from 'core/utils';
import { WalmartConnectedViewStore } from 'modules/channel/stores';

@setCurrentView(rootStore => new WalmartConnectedViewStore(rootStore), 'walmartConnectedViewStore')
class WalmartConnected extends React.Component {
	render() {
		return <WalmartConnectedTemplate {...this.props} viewStore={this.props.walmartConnectedViewStore} />;
	}
}

export default WalmartConnected;
